<template>
  <div class="generation-wrap">
    <div class="left-content">
      <div class="data-location" id="DataLocation">
        <div class="title">
          <div class="text">
            云图雅集
          </div>
          <div class="subText">
            CLOUD GRACE COLLECTED
          </div>
        </div>
        <transition appear appear-to-class="animate__animated animate__fadeIn">
          <div class="content" v-if="teaTemplateFilter.length > 0">
            <div
              class="item"
              :class="{ active: item.product.product_id === productId }"
              v-for="(item, index) in teaTemplateFilter"
              :key="index"
              @click="selectProduct(item)"
            >
              <img :src="item.main" alt="" width="100%" height="100%" />
              <img class="icon" src="@/assets/image/dagou.png" alt="" />
              <el-button
                class="detail-btn"
                size="mini"
                type="text"
                @click.stop="openItemPreview(item)"
                >详 情</el-button
              >
            </div>
          </div>
          <div class="content" v-else>
            <el-empty description="暂无编辑的产品"></el-empty>
          </div>
        </transition>
        <div class="foot">
          <div class="submit-btnn">
            <div style="display: flex;margin-bottom: 10px;align-items: center;">
              <span>评论设置</span>
              <el-select v-model="select1" placeholder="评论设置">
                <el-option label="开" value="开"> </el-option>
                <el-option label="关" value="关"> </el-option>
              </el-select>
              <span>价格设置</span>
              <el-select v-model="select2" placeholder="价格设置">
                <el-option label="活动价" value="活动价"> </el-option>
                <el-option label="正常价格" value="正常价格"> </el-option>
              </el-select>
            </div>
            <button @click="putaway" class="left" id="putawayBtn">
              <div class="text">
                上架商品
              </div>
              <div class="subText">
                Merchandise on the shelves
              </div>
            </button>
            <button class="right" @click="toNextRouter">
              <div class="text">
                下一步
              </div>
              <div class="subText">
                Merchandise on the shelves
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="right-content">
      <Shopee ref="shopee"></Shopee>
    </div>
    <stepDialog
      v-if="stepDialogStatus.show"
      :status="stepDialogStatus"
      @close="close"
    ></stepDialog>
    <el-dialog :visible.sync="previewVisible" title="信息预览" width="600px">
      <el-form :model="previewData" label-width="90px" class="preview-form">
        <el-form-item label="标题">
          <el-input
            v-model="previewData.title"
            placeholder="输入标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input
            type="textarea"
            :rows="4"
            v-model="previewData.description"
            placeholder="输入描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="主图 URL">
          <el-input
            v-model="previewData.image"
            placeholder="输入主图地址"
          ></el-input>
          <div style="margin-top:8px;">
            <img
              v-if="previewData.image"
              :src="previewData.image"
              alt="主图预览"
              style="max-width: 100%; max-height: 240px; object-fit: contain;"
            />
            <span v-else>—</span>
          </div>
        </el-form-item>
        <el-form-item label="附图">
          <div>
            <div
              v-for="(img, idx) in previewData.attachImages || []"
              :key="idx"
              style="display:flex;align-items:center;margin-bottom:10px;gap:10px;"
            >
              <el-upload
                class="avatar-uploader"
                :show-file-list="false"
                accept="image/*"
                :http-request="(opt) => handleAttachBase64Upload(opt, idx)"
              >
                <img v-if="img" :src="img" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <el-button type="text" @click="removeAttachImage(idx)"
                >移除</el-button
              >
            </div>
            <el-button type="primary" size="mini" @click="addAttachImage"
              >添加附图</el-button
            >
            <div style="margin-top:8px;">
              <template
                v-if="
                  Array.isArray(previewData.attachImages) &&
                    previewData.attachImages.length
                "
              >
                <img
                  v-for="(img, idx) in previewData.attachImages"
                  :key="'p-' + idx"
                  :src="img"
                  alt="附图"
                  style="width: 88px; height: 88px; object-fit: cover; margin: 4px; border: 1px solid #eee; border-radius: 4px;"
                />
              </template>
              <span v-else>—</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="高级编辑">
          <el-input
            type="textarea"
            :rows="8"
            v-model="previewJson"
            placeholder="可直接编辑完整参数 JSON"
          ></el-input>
          <div style="color:#999;font-size:12px;margin-top:4px;">
            解析失败时忽略 JSON 变更。
          </div>
        </el-form-item>
        <el-form-item label="评论设置">
          <el-input v-model="select1"></el-input>
        </el-form-item>
        <el-form-item label="价格设置">
          <el-input v-model="select2"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="previewVisible = false">关 闭</el-button>
        <el-button type="primary" @click="savePreview">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Shopee from "./shopee";
import stepDialog from "../../../components/stepDialog";
export default {
  components: {
    Shopee,
    stepDialog,
  },
  data() {
    return {
      select1: "开",
      select2: "正常价格",
      previewVisible: false,
      previewData: {},
      previewJson: "",
      teaTemplate: [
        {
          product: {
            product_id: "",
          },
        },
      ],
      productId: "",
      currentTemplateId: "",
      DriverInstance: null,
      stepDialogStatus: {
        show: false,
        in: false,
        start: 9,
        end: 10,
        page: "putaway",
      },
    };
  },
  computed: {
    teaTemplateFilter() {
      let $tea = this.teaTemplate.filter((item) => {
        return item.product;
      });
      return $tea;
    },
  },
  watch: {
    "stepDialogStatus.show": function(newv) {
      if (newv) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "initial";
      }
    },
    select1(newv) {
      try {
        localStorage.setItem("putaway_comment_setting", newv);
      } catch (e) {
        console.log(e);
      }
    },
    select2(newv) {
      try {
        localStorage.setItem("putaway_price_setting", newv);
      } catch (e) {
        console.log(e);
      }
    },
  },
  created() {
    if (!localStorage.getItem("putaway")) {
      setTimeout(() => {
        this.stepDialogStatus.show = true;
        this.stepDialogStatus.in = true;
      }, 2000);
    }

    this.$axios
      .post("/student/data/present/upload/template", {
        expId: this.$route.query.id,
      })
      .then((res) => {
        if (res.succeed) {
          this.teaTemplate = res.items;
          // 读取本地缓存并覆盖模板中缺失的参数
          this.overlayTemplateWithLocalCache();
        }
      });
    // 初始化评论与价格设置的本地缓存
    try {
      const cs = localStorage.getItem("putaway_comment_setting");
      if (cs) this.select1 = cs;
      const ps = localStorage.getItem("putaway_price_setting");
      if (ps) this.select2 = ps;
    } catch (e) {
      console.log(e);
    }
  },
  mounted() {
    // this.stepStart()
  },
  beforeRouteLeave(to, from, next) {
    if (this.DriverInstance) {
      this.DriverInstance.reset();
    }
    next();
  },
  methods: {
    // 选中商品对应的模板项（优先当前选中）
    getItemForSelectedProduct() {
      const list = this.teaTemplateFilter;
      if (!list || !list.length) return null;
      if (this.productId) {
        const found = list.find(
          (it) => it.product && it.product.product_id === this.productId
        );
        return found || list[0];
      }
      return list[0];
    },
    // 读取 comparison_product_cache 为数组
    getCacheArray() {
      try {
        const s = localStorage.getItem("comparison_product_cache");
        const p = s ? JSON.parse(s) : [];
        return Array.isArray(p) ? p : p ? [p] : [];
      } catch (e) {
        return [];
      }
    },
    // 判断值是否缺失（用于“覆盖缺失参数”）
    isMissing(v) {
      return v === undefined || v === null || v === "";
    },
    // 在模板列表里用本地缓存覆盖缺失参数
    overlayTemplateWithLocalCache() {
      const cacheArr = this.getCacheArray();
      if (!Array.isArray(this.teaTemplate)) return;
      this.teaTemplate = this.teaTemplate.map((item) => {
        if (!item || !item.product) return item;
        const pid = item.product.product_id;
        const tid = item.template_id;
        const expId = this.$route.query.id;
        const local = cacheArr.find((it) => {
          if (!it) return false;
          // 优先使用实验ID+模板ID匹配
          if (it.expId === expId && it.templateId === tid) return true;
          // 兼容旧缓存：无 expId 但模板匹配
          if (!it.expId && it.templateId === tid) return true;
          // 兼容旧逻辑：通过 productId 匹配
          if (pid && it.productId === pid) return true;
          return false;
        });
        if (local) {
          // 仅覆盖缺失字段
          Object.keys(local).forEach((k) => {
            if (k in item.product && this.isMissing(item.product[k])) {
              item.product[k] = local[k];
            }
          });
          // 主图与附图处理
          if (this.isMissing(item.main) && local.image) item.main = local.image;
          if (Array.isArray(local.attachImages)) {
            if (this.isMissing(item.product.attachImages)) {
              item.product.attachImages = local.attachImages;
            }
            if (this.isMissing(item.product.attachments)) {
              item.product.attachments = local.attachImages;
            }
          }
        }
        return item;
      });
    },
    openPreview() {
      const item = this.getItemForSelectedProduct();
      if (item) {
        this.resetPreviewFromItem(item);
      } else {
        // 无服务端列表时，回退到本地缓存最后一项
        try {
          const cacheStr = localStorage.getItem("comparison_product_cache");
          let parsed = [];
          try {
            parsed = cacheStr ? JSON.parse(cacheStr) : [];
          } catch (_) {
            parsed = [];
          }
          const arr = Array.isArray(parsed) ? parsed : parsed ? [parsed] : [];
          this.previewData = arr.length ? arr[arr.length - 1] || {} : {};
          this.previewJson = JSON.stringify(this.previewData, null, 2);
          this.currentTemplateId = "";
        } catch (e) {
          this.previewData = {};
          this.previewJson = "";
          this.currentTemplateId = "";
        }
      }
      this.previewVisible = true;
    },
    // 打开指定商品的详细参数预览（服务端参数+本地覆盖）
    openItemPreview(item) {
      this.resetPreviewFromItem(item);
      this.previewVisible = true;
    },
    // 使用指定模板项重置预览数据（服务端为基线+本地覆盖）
    resetPreviewFromItem(item) {
      const cacheArr = this.getCacheArray();
      const base =
        item && item.product ? JSON.parse(JSON.stringify(item.product)) : {};
      const tid = item ? item.template_id : undefined;
      const expId = this.$route.query.id;
      // 详情预览：直接通过实验ID+模板ID在本地缓存中查找
      let local = cacheArr.find(
        (it) => it && it.expId === expId && it.templateId === tid
      );
      // 兼容旧缓存（无 expId）
      if (!local) {
        local = cacheArr.find((it) => it && !it.expId && it.templateId === tid);
      }
      if (local) {
        // 只渲染本地缓存内容进行回填
        this.previewData = JSON.parse(JSON.stringify(local));
      } else {
        // 无本地缓存时回退到服务端基线
        const merged = { ...base };
        merged.image = !this.isMissing(item && item.main)
          ? item.main
          : merged.image;
        const serverImgs = Array.isArray(base.attachImages)
          ? base.attachImages
          : Array.isArray(base.attachments)
          ? base.attachments
          : undefined;
        if (Array.isArray(serverImgs) && serverImgs.length) {
          merged.attachImages = serverImgs;
        }
        this.previewData = merged;
      }
      // 确保至少有一个上传位
      if (
        !Array.isArray(this.previewData.attachImages) ||
        this.previewData.attachImages.length === 0
      ) {
        this.$set(this.previewData, "attachImages", [""]);
      }
      this.currentTemplateId = tid || "";
      try {
        this.previewJson = JSON.stringify(this.previewData, null, 2);
      } catch (_) {
        this.previewJson = "";
      }
      console.log(this.previewData);
    },
    // 添加/移除附图
    addAttachImage() {
      if (!Array.isArray(this.previewData.attachImages)) {
        this.$set(this.previewData, "attachImages", []);
      }
      this.previewData.attachImages.push("");
    },
    removeAttachImage(idx) {
      if (Array.isArray(this.previewData.attachImages)) {
        this.previewData.attachImages.splice(idx, 1);
      }
      this.persistCacheEntry();
    },
    // 上传附图成功，写入对应下标
    handleAttachSuccess(response, file, fileList, idx) {
      const ok =
        response && (response.succeed === true || response.succeed === "true");
      const path =
        response && (response.path || (response.data && response.data.path));
      if (ok && path) {
        if (!Array.isArray(this.previewData.attachImages)) {
          this.$set(this.previewData, "attachImages", []);
        }
        this.$set(this.previewData.attachImages, idx, path);
        try {
          this.previewJson = JSON.stringify(this.previewData, null, 2);
        } catch (_) {
          console.log(_);
        }
        this.$message({ type: "success", message: "附图上传成功" });
        // 即时持久化有效附图到缓存
        this.persistCacheEntry();
      } else {
        this.$message({ type: "error", message: "上传失败" });
      }
    },
    // 自定义上传：将本地图片文件读取为 Base64，并写入对应附图位
    handleAttachBase64Upload(opt, idx) {
      try {
        const file = opt && opt.file;
        if (!file) {
          if (opt && typeof opt.onError === "function")
            opt.onError(new Error("No file"));
          return;
        }
        const reader = new FileReader();
        reader.onload = (e) => {
          const dataUrl = e.target && e.target.result;
          if (!dataUrl) {
            if (opt && typeof opt.onError === "function")
              opt.onError(new Error("Read failed"));
            return;
          }
          if (!Array.isArray(this.previewData.attachImages)) {
            this.$set(this.previewData, "attachImages", []);
          }
          this.$set(this.previewData.attachImages, idx, String(dataUrl));
          try {
            this.previewJson = JSON.stringify(this.previewData, null, 2);
          } catch (_) {
            console.log(_);
          }
          // 即时持久化到缓存（写入 attachments 兼容字段）
          this.persistCacheEntry();
          if (opt && typeof opt.onSuccess === "function")
            opt.onSuccess({ base64: dataUrl }, file);
          this.$message({ type: "success", message: "附图已添加（Base64）" });
        };
        reader.onerror = (err) => {
          if (opt && typeof opt.onError === "function") opt.onError(err);
          this.$message({ type: "error", message: "读取图片失败" });
        };
        reader.readAsDataURL(file);
      } catch (e) {
        if (opt && typeof opt.onError === "function") opt.onError(e);
        this.$message({ type: "error", message: "上传异常" });
      }
    },
    // 将当前预览数据持久化到本地缓存（仅当存在有效附图时）
    persistCacheEntry() {
      const cache = this.getCacheArray();
      const expId =
        (this.$route && this.$route.query && this.$route.query.id) || "";
      const productId = this.previewData.product_id || this.productId || "";
      const templateId =
        this.currentTemplateId || this.previewData.templateId || "";
      const entry = {
        ...this.previewData,
        expId: expId || undefined,
        productId: productId || undefined,
        templateId: templateId || undefined,
        savedAt: Date.now(),
      };
      if (Array.isArray(entry.attachImages)) {
        entry.attachImages = entry.attachImages.filter((x) => !!x);
      }
      if (
        !entry.image &&
        Array.isArray(entry.attachImages) &&
        entry.attachImages.length
      ) {
        entry.image = entry.attachImages[0];
      }
      // 没有有效附图则不写入，避免覆盖为“空附图”
      if (
        !Array.isArray(entry.attachImages) ||
        entry.attachImages.length === 0
      ) {
        return;
      }
      // 兼容字段：同时写入 attachments
      entry.attachments = entry.attachImages;
      let idx = -1;
      if (templateId) {
        idx = cache.findIndex(
          (it) => it && it.expId === expId && it.templateId === templateId
        );
        if (idx < 0) {
          idx = cache.findIndex(
            (it) => it && !it.expId && it.templateId === templateId
          );
        }
      }
      if (idx < 0 && productId) {
        idx = cache.findIndex((it) => it && it.productId === productId);
      }
      if (idx >= 0) {
        cache.splice(idx, 1, entry);
      } else {
        cache.push(entry);
      }
      try {
        localStorage.setItem("comparison_product_cache", JSON.stringify(cache));
      } catch (e) {
        console.log(e);
      }
    },
    // 保存预览中的编辑内容到本地缓存（comparison_product_cache）
    savePreview() {
      // 若 JSON 填写有效，则覆盖到 previewData
      if (this.previewJson) {
        try {
          const parsed = JSON.parse(this.previewJson);
          Object.keys(parsed).forEach((k) => {
            this.$set(this.previewData, k, parsed[k]);
          });
        } catch (_) {
          // 解析失败则忽略 JSON 变更
        }
      }
      const cache = this.getCacheArray();
      const expId =
        (this.$route && this.$route.query && this.$route.query.id) || "";
      const productId = this.previewData.product_id || this.productId || "";
      const templateId = this.currentTemplateId || "";
      const entry = {
        ...this.previewData,
        expId: expId || undefined,
        productId: productId || undefined,
        templateId: templateId || this.previewData.templateId || undefined,
        savedAt: Date.now(),
      };
      if (Array.isArray(entry.attachImages)) {
        entry.attachImages = entry.attachImages.filter((x) => !!x);
      }
      if (
        !entry.image &&
        Array.isArray(entry.attachImages) &&
        entry.attachImages.length
      ) {
        entry.image = entry.attachImages[0];
      }
      // 兼容字段写入
      entry.attachments = entry.attachImages;
      let idx = -1;
      // 优先用实验ID+模板ID匹配更新已有缓存
      if (templateId) {
        idx = cache.findIndex(
          (it) => it && it.expId === expId && it.templateId === templateId
        );
        if (idx < 0) {
          // 兼容旧缓存：无 expId
          idx = cache.findIndex(
            (it) => it && !it.expId && it.templateId === templateId
          );
        }
      }
      // 再兼容旧逻辑：通过 productId 匹配
      if (idx < 0 && productId) {
        idx = cache.findIndex((it) => it && it.productId === productId);
      }
      if (idx >= 0) {
        cache.splice(idx, 1, entry);
      } else {
        cache.push(entry);
      }
      try {
        localStorage.setItem("comparison_product_cache", JSON.stringify(cache));
        this.$message({ type: "success", message: "已保存到本地缓存" });
      } catch (e) {
        this.$message({ type: "error", message: "保存失败：本地存储不可写" });
      }
      // 保存后刷新模板缺失字段的覆盖效果
      this.overlayTemplateWithLocalCache();
      this.previewVisible = false;
    },
    close() {
      this.stepDialogStatus.in = false;
      setTimeout(() => {
        this.stepDialogStatus.show = false;
      }, 1000);
    },
    stepStart() {
      if (!localStorage.getItem("Putaway1")) {
        this.DriverInstance = this.Driver("Putaway1");
        setTimeout(() => {
          this.DriverInstance.start();
        }, 2000);
      }
    },
    toNextRouter() {
      this.$router.push({
        path: "/data/result",
        query: Object.assign(this.$route.query, { id: this.$route.query.id }),
      });
    },
    selectProduct(item) {
      this.productId =
        item.product.product_id === this.productId
          ? ""
          : item.product.product_id;
    },
    putaway() {
      this.$axios
        .post("/student/data/present/online/product", {
          productId: this.productId,
          type: true,
        })
        .then((res) => {
          if (res.succeed) {
            this.$message({
              message: res.message,
              type: "success",
            });
            this.$refs["shopee"].getList();
          } else {
            this.$message({
              message: res.message,
              type: "error",
              customClass: "customClass",
            });
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
@mixin title {
  padding-bottom: 0;
  margin-bottom: 10px;
  .text {
    font-size: 26px;
    font-weight: bold;
    line-height: 33px;
  }
  .subText {
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
    color: #999999;
  }
}

.generation-wrap {
  display: flex;

  .left-content {
    width: 400px;
    height: 722px;
    margin-right: 40px;
    background: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    border-radius: 12px;

    .data-location {
      width: 100%;
      height: 100%;
      padding: 30px;
      display: flex;
      flex-direction: column;
      box-shadow: 0 0 4px #cacaca;
      border-radius: 10px;

      .title {
        @include title;
        margin-bottom: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .preview-btn {
          margin-left: 12px;
        }
      }

      .content {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        .has {
          flex-grow: 1;
          display: flex;
          flex-wrap: wrap;
          align-content: flex-start;
          overflow-y: auto;
        }

        .item {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 160px;
          height: 160px;
          text-align: center;
          margin-right: 20px;
          background: #ffffff;
          border: 1px solid #f1f1f1;
          border-radius: 6px;
          overflow: hidden;
          margin-bottom: 16px;
          position: relative;
          cursor: pointer;

          &:nth-child(even) {
            margin-right: 0;
          }

          .icon {
            width: 0;
            height: 0;
            position: absolute;
            bottom: 6px;
            right: 6px;
            z-index: -1;
            transition: all 0.3s linear;
          }

          &:hover {
            box-shadow: 0 0 10px #cacaca;
          }

          &.active .icon {
            width: 30px;
            height: 30px;
            z-index: 9;
            transition: all 0.3s linear;
          }

          .detail-btn {
            position: absolute;
            background: #005be7;
            color: #ffffff;
            top: 6px;
            right: 6px;
            z-index: 10;
          }
        }
      }

      .foot {
        .submit-btnn {
          button {
            width: 50%;
            height: 64px;
            background: linear-gradient(90deg, #70a0eb 0%, #005be7 100%);
            box-shadow: 0px 3px 6px rgba(0, 91, 231, 0.3);
            opacity: 1;
            border-radius: 60px;

            &.left {
              border-radius: 60px 0 0 60px;
            }

            &.right {
              border-radius: 0 60px 60px 0;
            }

            .text {
              font-size: 22px;
              font-family: Microsoft YaHei UI;
              font-weight: 400;
              line-height: 26px;
              color: #ffffff;
            }

            .subText {
              font-size: 10px;
              font-weight: 400;
              line-height: 14px;
              color: #ffffff;
            }
          }
        }
      }
    }
  }

  .right-content {
    flex-grow: 1;
    flex-shrink: 1;
    height: 722px;
    background: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    opacity: 1;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
/* 上传样式（与 imgEdit.vue 保持一致的体验） */
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  line-height: 88px;
  text-align: center;
}
.avatar {
  width: 88px;
  height: 88px;
  display: block;
  object-fit: cover;
  border: 1px solid #eee;
  border-radius: 4px;
}
</style>
